import { CATEGORY_COLORS } from '@/constants/app';

/**
 * Categories are never configured, so their colour is derived from the name.
 * The same name always gets the same colour, in both themes.
 */
export function categoryColorIndex(category: string): number {
  const key = category.trim().toLowerCase();
  let hash = 2166136261;
  for (let i = 0; i < key.length; i += 1) {
    hash ^= key.charCodeAt(i);
    hash = Math.imul(hash, 16777619);
  }
  return Math.abs(hash) % CATEGORY_COLORS.length;
}

export function categoryColor(category: string, theme: 'light' | 'dark'): string {
  return CATEGORY_COLORS[categoryColorIndex(category)]![theme];
}
